import styled from 'styled-components';

import { donedealBreakpoints } from 'styled-system';
import { Text } from '../../../ToolkitV2/Text/Text';

const { media } = donedealBreakpoints;

export const Heading = styled(Text)`
  display: block;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing.M16};

  ${media.medium} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
`;

export const BreakdownPanel = styled.div`
  padding: ${({ theme }) => theme.spacing.M16};
  background-color: ${({ theme }) => theme.donedeal.colors.GREY_LIGHTER};
  border-radius: 4px;
`;

export const MonthlyPriceHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const BreakdownList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
`;

export const BreakdownItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
